// ======================================================================
// File Name       : ContentDrillSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import React from 'react';
import { Form, FormControl, Col, InputGroup, Button, Row } from 'react-bootstrap';
import SelectBox from '../../components/SelectBox';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import { DATA_AFFIILIATION_TYPE } from '../../constants/ContentConstant';
import { VALIDATE_TYPE } from '../../constants/index';
import FormControlValidate from '../FormControlValidate';
import DateTimeWithValidate from '../../components/DateTimeWithValidate';
import DateTimeMinMax from '../../components/DateTimeMinMax';
import CustomButton from '../button/CustomButton';
import * as Path from '../../constants/PathConstants';
import * as FUNCTION from '../../constants/FunctionConstants';
import * as ICON from '../../constants/IconConstants';
import CustomLink from '../button/CustomLink';
import { canAccessRoute } from '../../utils/AuthedUtils';

class ContentDrillSearch extends React.Component {
  constructor() {
    super();
    this.validation = this.validation.bind(this);
  }
  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }
  render() {
    const {
      drillSecernId,
      drillTitle,
      drillKind,
      convertStatus,
      startDate,
      endDate,
      dataAffiliationType,
      drillSortType,
      ascendingDescendingSort,
      getStartEndData,
      startPosition,
      recordNum,
      returnMaxNum,
      handleChange,
      handleTimeChange,
      handleChangeRadioButton,
      onSearchBtnClick,
      onExportBtnClick,
      createdUserName, // Step 9.0.0
    } = this.props;
    this.refsToValidate = [];
    const canAccessRegister = canAccessRoute(FUNCTION.CONTENT_DRILL_REGISTER);
    const canAccessImport = canAccessRoute(FUNCTION.CONTENT_DRILL_IMPORT);
  
    return (
      <Col sm={12} className="padding-left-right-clear">
        <h3>検索する項目を指定してください</h3>
        <Col sm={12} className="padding-top-10 padding-left-right-clear">
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              onSearchBtnClick();
            }}
            className="form-horizontal"
          >
            <Col sm={12}>
              <Form.Group className="form-info">
                <Col as={Form.Label} sm={3}>
                  ドリル識別ID
                </Col>
                <Col sm={7}>
                  <FormControlValidate
                    type="text"
                    name="drillSecernId"
                    value={drillSecernId}
                    onChange={handleChange}
                    maxLength="64"
                    validateType={VALIDATE_TYPE.ID}
                    ref={(ref) => {
                      if (ref) {
                        this.refsToValidate.push(ref);
                      }
                    }}
                    label="ドリル識別ID"
                  />
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col as={Form.Label} sm={3}>
                  ドリルタイトル
                </Col>
                <Col sm={7}>
                  <FormControl
                    type="text"
                    name="drillTitle"
                    value={drillTitle}
                    onChange={handleChange}
                    maxLength="256"
                  />
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col as={Form.Label} sm={3}>
                  ドリル種別
                </Col>
                <Col sm={7}>
                  <SelectBox
                    data={SELECT_BOX_DATA.DRILL_KIND_LIST}
                    name="drillKind"
                    value={drillKind}
                    onChange={handleChange}
                  />
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col as={Form.Label} sm={3}>
                  変換ステータス
                </Col>
                <Col sm={7}>
                  <SelectBox
                    data={SELECT_BOX_DATA.DRILL_STATUS}
                    name="convertStatus"
                    value={convertStatus}
                    onChange={handleChange}
                  />
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col sm={3} as={Form.Label}>
                  登録日
                </Col>
                <Col sm={3}>
                  <DateTimeWithValidate
                    onChange={(dateString) =>
                      handleTimeChange("startDate", dateString)
                    }
                    ref={(ref) => {
                      if (ref) {
                        this.refsToValidate.push(ref);
                      }
                    }}
                    value={startDate || ""}
                  />
                </Col>
                <Col sm={1} className="text-center" as={Form.Label}>
                  ～
                </Col>
                <Col sm={3}>
                  <DateTimeWithValidate
                    onChange={(dateString) =>
                      handleTimeChange("endDate", dateString)
                    }
                    ref={(ref) => {
                      if (ref) {
                        this.refsToValidate.push(ref);
                      }
                    }}
                    value={endDate || ""}
                  />
                </Col>
                <Col sm={12}>
                  <DateTimeMinMax
                    dateFrom={startDate}
                    dateTo={endDate}
                    ref={(ref) => {
                      if (ref) {
                        this.refsToValidate.push(ref);
                      }
                    }}
                  />
                </Col>
              </Form.Group>
              {/* Step 9.0.0 START */}
              <Form.Group className="form-info">
                <Col as={Form.Label} sm={3}>
                  登録者
                </Col>
                <Col sm={7}>
                  <FormControl
                    type="text"
                    name="createdUserName"
                    value={createdUserName}
                    onChange={handleChange}
                    maxLength="40"
                  />
                </Col>
              </Form.Group>
              {/* Step 9.0.0 END */}
              <Form.Group className="form-info">
                <Col as={Form.Label} sm={3}>
                  自サービス/外部
                </Col>
                <Col sm={9} className="padding-top-10">
                  <Form.Check
                    type="radio"
                    inline
                    className="padding-top-clear"
                    name="dataAffiliationType"
                    id={`dataAffiliationType-${DATA_AFFIILIATION_TYPE.NOT_SELECT}`}
                    value={DATA_AFFIILIATION_TYPE.NOT_SELECT}
                    checked={
                      dataAffiliationType === DATA_AFFIILIATION_TYPE.NOT_SELECT
                    }
                    onChange={handleChangeRadioButton}
                    label="選択なし"
                  ></Form.Check>
                  <Form.Check
                    type="radio"
                    className="margin-left-15 padding-top-clear"
                    inline
                    name="dataAffiliationType"
                    id={`dataAffiliationType-${DATA_AFFIILIATION_TYPE.INTERNAL}`}
                    value={DATA_AFFIILIATION_TYPE.INTERNAL}
                    checked={
                      dataAffiliationType === DATA_AFFIILIATION_TYPE.INTERNAL
                    }
                    onChange={handleChangeRadioButton}
                    label="自サービスコンテンツ"
                  ></Form.Check>
                  <Form.Check
                    type="radio"
                    className="margin-left-15 padding-top-clear"
                    inline
                    name="dataAffiliationType"
                    id={`dataAffiliationType-${DATA_AFFIILIATION_TYPE.EXTERNAL}`}
                    value={DATA_AFFIILIATION_TYPE.EXTERNAL}
                    checked={
                      dataAffiliationType === DATA_AFFIILIATION_TYPE.EXTERNAL
                    }
                    onChange={handleChangeRadioButton}
                    label="外部コンテンツ"
                  ></Form.Check>
                </Col>
              </Form.Group>
            </Col>
            <Form.Group className="text-center">
              <Col sm={12} className="text-center margin-top-20 margin-bottom-20">
                <CustomButton
                  btnStyle="btn btn-primary btn-96"
                  type="submit"
                  text="検索"
                  iconClass="bi bi-search"
                />
              </Col>
            </Form.Group>
            <Form.Group>
              <Row className="margin-bottom-15">
                <Col sm={9} className="inline-flex">
                  {canAccessRegister && (
                    <CustomLink
                      className="margin-right-7 btn-register margin-right-10"
                      to={Path.CONTENT_DRILL_REGISTER}
                      text="ドリル追加"
                      icon={ICON.REGIST}
                    />
                  )}
                  {canAccessImport && (
                    <CustomLink
                      className="margin-right-7 btn-csv-import"
                      to={Path.CONTENT_DRILL_IMPORT}
                      text="CSV一括投入"
                      icon={ICON.IMPORT}
                    />
                  )}
                </Col>
                <Col sm={3}>
                  <CustomButton
                    btnStyle="btn btn-export-csv float-end"
                    handleClick={onExportBtnClick}
                    text="一括出力"
                    iconClass="bi bi-download"
                  />
                </Col>
              </Row>
            </Form.Group>
          </Form>
        </Col>
      </Col>
    );
  }
}

export default ContentDrillSearch;
